export var VALID_RESULT = {
  isValid: true
};